class BackgroundVideo extends HTMLElement {
  constructor () {
    super()

    this.video = this.querySelector('video')
    this.pauseButton = this.querySelector('background-video-pause-button')
    this.initSources = this.dataset.initSources || 'true'

    this.video.addEventListener('canplay', () => {
      this.video.classList.remove('opacity-0')
      window.addEventListener('resize', this.updateSrc.bind(this))
    })

    if (this.initSources == 'true') {
      this.updateSrc()
    }
  }

  pause () {
    this.video.pause()
    this.pauseButton.setAttribute('data-playing', 'false')
    this.pauseButton.setAttribute('aria-label', this.pauseButton.getAttribute('data-play'))
  }

  resume () {
    this.video.play()
    this.pauseButton.setAttribute('data-playing', 'true')
    this.pauseButton.setAttribute('aria-label', this.pauseButton.getAttribute('data-pause'))
  }

  updateSrc() {
    const sources = this.querySelectorAll('video source')
    let selectedSource

    sources.forEach((sourceEl) => {
      const sourceMediaQuery = sourceEl.getAttribute('media')

      if (!sourceMediaQuery) {
        selectedSource = sourceEl
      } else if (window.matchMedia(sourceMediaQuery).matches) {
        selectedSource = sourceEl
      }
    })

    const selectedSourceValue = selectedSource.getAttribute('data-src')

    this.pauseButton?.setAttribute('data-playing', 'true')

    if (this.video.src !== selectedSourceValue) {
      this.video.src = selectedSourceValue
    }
  }
}

customElements.define('background-video', BackgroundVideo)

class BackgroundVideoPauseButton extends HTMLElement {
  constructor () {
    super()

    this.bgVideo = this.closest('background-video')
  }

  handleClick() {
    if (!this.bgVideo.video.paused) {
      this.bgVideo.pause()
    } else {
      this.bgVideo.resume()
    }
  }

  handleClickBtn() {
    this.handleClick()
  }

  handleKeyDownBtn(event) {
    if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") {
      this.handleClick()
    }
  }
}

customElements.define('background-video-pause-button', BackgroundVideoPauseButton)
